import './App.css';
import Header from './Header';

function TeamPage() {
  return (
    <div className="team-page">
      <Header dark={true} />

      <section className="section-people">
        <div className="section-people-inner">
          <h2 className="section-title">Our Team</h2>
          <div className="people-grid-top">
            {[
                { name: "Mitchell Mutz, PhD", role: "Chief Executive Officer", image: "/folk/Mitchell.webp", bio: "Accomplished venture investor, biotech serial entrepreneur, and inventor. He is on the investing team at Samsara Biocapital. Previously: co-founder and CSO of Amplyx Pharmaceuticals, acquired by Pfizer; co-founder and chief scientist of Labcyte, acquired by Danaher." },
                { name: "Yann Astier, PhD", role: "Chief Scientific Officer", image: "/folk/Yann.webp", bio: "Former Senior Research Fellow at Oxford University, Research Team Leader at IBM Research, and Director of Research at Roche Sequencing Solutions." },
                { name: "Cindy Yee", role: "Chief Operations Officer", image: "/folk/Cindy.webp", bio: "Specializes in company building, corporate strategy, operational leadership, and value creation, with over 25 years of experience helping life science companies translate innovative technologies into impactful products across research, diagnostics, and therapeutics." },
                { name: "Ariel Notcovich, PhD", role: "Advisor", image: "/folk/Ariel.webp", bio: "Former Bio-Rad executive, CEO of Bluelight Therapeutics and CTO of Biolog Inc. Now serves as a fractional leader for high-growth tech-bio companies and the Entrepreneur-in-Residence (EIR) at UC Berkeley" },
                { name: "Franta Foret, PhD", role: "Advisor", image: "/folk/Franta.webp", bio: "Director of the Institute of Analytical Chemistry of the Czech Academy of Sciences and former research group leader at the Barnett Institute, Northeastern University. Pioneer in capillary electrophoresis, microfluidics, and mass spectrometry coupling, with 200+ publications and 25 patents." },
            ].map((chief, i) => (
              <div key={i} className="person-card-top" tabIndex={0}>
                {chief.image
                  ? <img src={chief.image} alt={chief.name} className="person-avatar-top" />
                  : <div className="person-avatar-top" />}
                <p className="person-name">{chief.name}</p>
                <p className="person-role">{chief.role}</p>
                {chief.bio &&
                  <div className="person-bio">
                    <p className="person-bio-text">{chief.bio}</p>
                  </div>
                }
              </div>
            ))}
          </div>
          <div className="people-grid-bottom">
            {[
              // { name: "Yutaka Hashimoto, PhD", role: "RNA Extraction", image: "/folk/Yutaka.webp", bio: "Curiosity-driven Molecular Biologist with a career spanning UCSF and Bay Area biotech — 14+ years pushing the boundaries of RNA biology, cancer epigenetics, and biomarker discovery." },
              { name: "Adrian Ramirez, PhD", role: "DNA Extraction", image: "/folk/Adrian.webp", bio: "PhD in Molecular Biology from the University of Colorado Boulder." },
              { name: "Kat Uniewicz, PhD", role: "Operations", image: "/folk/Kat.webp", bio: "Drawing on experience from Abbott and Qiagen, Kat builds quality frameworks, streamlines operations, and guides the team through compliance and manufacturing challenges. She is passionate about creating simple solutions to complex problems." },
              { name: "Nathan Lapp", role: "Research Associate", image: "/folk/Nathan.webp", bio: "Bachelors in Molecular Biology from UC Berkeley. 3+ years of experience in bioengineering and FACS. Passion for Fish, Fungi, and Trees." },
              { name: "Arman Omidvar", role: "Automation Engineer", image: "/folk/Arman.webp", bio: "University of California, Berkeley: Statistics and Data Science with a concentration in Plant Molecular Biology. Deeply interested in the intersection of technology and genomics." },
            ].map((employee, i) => (
              <div key={i} className="person-card-bottom" tabIndex={0}>
                {employee.image
                  ? <img src={employee.image} alt={employee.name} className="person-avatar-bottom" />
                  : <div className="person-avatar-bottom" />}
                <p className="person-name">{employee.name}</p>
                <p className="person-role">{employee.role}</p>
                {employee.bio &&
                  <div className="person-bio">
                    <p className="person-bio-text">{employee.bio}</p>
                  </div>
                }
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default TeamPage;
